import { Assert } from '@team/assert';
import { CacheDefinition } from './interfaces';
import { InnerKey, Serializer } from './types';

export class Cache<V = unknown, K = InnerKey> implements CacheDefinition<V, K> {
  private readonly cache = new Map<InnerKey, V>();

  constructor(private readonly serializer: Serializer = JSON.stringify) {}

  public has(key: K): boolean {
    const innerKey = this.createInnerKey(key);

    return this.cache.has(innerKey);
  }

  public get(key: K): Maybe<V> {
    const innerKey = this.createInnerKey(key);

    return this.cache.get(innerKey);
  }

  public set(key: K, value: V): this {
    const innerKey = this.serializer(key);

    this.cache.set(innerKey, value);

    return this;
  }

  private createInnerKey(key: K) {
    if (Assert.isString(key)) {
      return key;
    }

    return this.serializer(key);
  }
}
